module.exports = __webpack_public_path__ + "static/media/survey-on-phone-French.a010a1a7.png";